import { DEFAULT_GRATIFICATION_DURATION_WITH_LOTTIE } from "@super-ui/components/cart-upsell-nudge";
import { SWIGGY_ONE_ADDED_TEXT, SWIGGY_ONE_LITE_ADDED_TEXT } from "@super-ui/components/m2c-swiggy-one-halfcard";

export const GRATIFICATION_POPUP_TEXTS = {
    SAVINGS_CALLOUT: "Total bill reduced by ₹{0} with {1}",
    SWIGGY_ONE_ADDED_TEXT,
    SWIGGY_ONE_LITE_ADDED_TEXT,
    CTA: "YAY!",
    VISIBILITY_TIME: DEFAULT_GRATIFICATION_DURATION_WITH_LOTTIE,
};

export const GRATIFICATION_POPUP_PLAN_NAMES = {
    PLUS: "Swiggy One",
    LITE: "Swiggy One Lite",
    BLACK: "Swiggy Black",
};
